import * as AgendaEffects from './events.effect';
import * as featuredEventEffects from './featured-events.effect';
import * as relatedEventEffects from './related-events.effect';
import * as FilterFieldsEffects from './filter-fields.effect';

export const effects = { ...AgendaEffects, ...featuredEventEffects, ...relatedEventEffects, ...FilterFieldsEffects };
